import React, { useEffect, useState, useRef } from "react";
import { useFormik } from "formik";
import { Link, useLocation, useNavigate } from "react-router-dom";

import {
  getChargBasesData,
  updateService,
  getServiceType,
  GetserviceByIdApi,
} from "../../../ReduxStore/Slice/Pricing/ServiceSlice";
import { getChargeBasis } from "../../../ReduxStore/Slice/Pricing/ChargeBasisSlice";
import { useDispatch, useSelector } from "react-redux";
import { ScrollToViewFirstError } from "../../../Utils/CommonFun";
import { agentDetails } from "../../../ReduxStore/Slice/Auth/AuthSlice";
import {
  EMPTY_SERVICE_TYPE_ERROR,
  EMPTY_SERVICE_NAME_ERROR,
  EMPTY_SERVICE_CHARGE_BASIS_ERROR,
  EMPTY_SERVICE_PRICE_RATE_ERROR,
  EMPTY_SERVICE_MIN_BASE_PRICE_ERROR,
  EMPTY_SERVICE_CHARGE_TYPE_ERROR,
  EMPTY_SERVICE_DEFAULT_CHARG_BASIS,
  EMPTY_SERVICE_INCREMENTAL_RULE_ERROR,
  EMPTY_CHARGE_BASIS,
  EMPTY_CHARGE_BASIS_ONE,
  EMPTY_ADD_ON_PRICE
} from "../../../Utils/Common_Error";
import Swal from "sweetalert2";
import { number } from "yup";

const CreateServices = () => {
  const dispatch = useDispatch();
  const location = useLocation();
  const navigate = useNavigate();
  const token = localStorage.getItem("token");
  const textareaRef = useRef(null);
  const textareaRefBenefits = useRef(null);
  const [isFormInitialized, setIsFormInitialized] = useState(false);
  const [isUsedService, setIsUsedService] = useState(false);

  // console.log("isUsedService", isUsedService);

  const agent_id = JSON.parse(localStorage.getItem("agent_id"));
  const [chargeBases, setChargeBases] = useState([]);
  const [serviceChargeBases, setServiceChargeBases] = useState([
    {
      chargebasis_id: null,
      price_rate: null,
      min_base_price: null,
      incremental_price: null,
      chargebasis_asc_order: null,
      operator: "+",
      chargetypes: [],
      rate_cutoff: null,
      add_on_price: null,
    },
  ]);

  const [agentData, setAgentData] = useState({});
  // console.log("agentData", agentData.vat_registered);

  const hasBasisType5 = serviceChargeBases?.some(item => Number(item?.basistypes_id) === 5);

  // console.log("serviceChargeBases", serviceChargeBases);
  const [serviceTypeData, setServiceTypeData] = useState([]);
  useEffect(() => {
    if (agent_id) {
      getAgentList();
      fetchInitialData();
      GetServiceDataById();
    }
  }, [agent_id]);

  const getAgentList = async () => {
    const req = { agent_id: agent_id }
    await dispatch(agentDetails(req)).unwrap()
      .then(async (res) => {
        if (res.status) {
          //console.log("res -- agents details", res)
          setAgentData(res.data);
        }
        else {
          setAgentData({});
        }
      })
      .catch((err) => {
        console.log("Error", err)
      })
  }

  const fetchInitialData = async () => {
    try {
      const [chargeBaseRes, serviceTypeRes] = await Promise.all([
        dispatch(getChargBasesData({ agent_id })).unwrap(),
        dispatch(getServiceType({ token, agent_id })).unwrap(),
      ]);

      let FilteredData = chargeBaseRes.data.filter((item) => item?.status == 1);

      setChargeBases(chargeBaseRes.status ? FilteredData : []);
      setServiceTypeData(serviceTypeRes.status ? serviceTypeRes.data : []);
    } catch (error) {
      setChargeBases([]);
      setServiceTypeData([]);
    }
  };

  const hasMinimumTwoValidIds = (array, num, notMatch) => {
    const validItems = array.filter(
      (item) =>
        item.chargebasis_id !== null &&
        item.chargebasis_id !== "null" &&
        item.chargebasis_id !== "" &&
        item.chargebasis_id !== undefined
    );

    if (notMatch) {
      // Filter out items whose `basistypes_id` is in the `notMatch` array
      const excludedItems = validItems.filter(
        (item) => item?.basistypes_id != notMatch
      );

      return excludedItems.length >= num;
    }

    return validItems.length >= num;
  };

  const CheckValidArrayLength = (data, notInclude) => {
    const validItems = data.filter(
      (item) =>
        item.chargebasis_id !== null &&
        item.chargebasis_id !== "null" &&
        item.chargebasis_id !== "" &&
        item.chargebasis_id !== undefined
    );

    // Filter out items whose `basistypes_id` is in the `notInclude` array
    const excludedItems = validItems.filter((item) =>
      notInclude.includes(item?.basistypes_id)
    );

    // If any items are excluded, return 0
    if (excludedItems.length > 0) {
      return 0;
    }

    // Otherwise return number of valid items
    return validItems.length;
  };

  const formik = useFormik({
    initialValues: {
      agent_id: agent_id,
      name: "",
      serviceType: "",
      description: "",
      benefits: "",
      vat_exempt: false,
      default_chargebasis_id: null,
      chargebasis_dependent_other: "0",
      incremental_rule: "0",
      custom_rule: "0",
      frequency_status: "0",
      frequency_optional_chargebasis_id: null,
      link_frequency_rule: "0",
      status: "1",
      chargeBasisArray: [],
      defaultChargeBasis: null,
    },

    validate: (values) => {
      let errors = {};
      if (!isFormInitialized) return errors;
      if (!values.name) {
        errors.name = EMPTY_SERVICE_NAME_ERROR;
      }
      if (!values.serviceType) {
        errors.serviceType = EMPTY_SERVICE_TYPE_ERROR;
      }

      if (serviceChargeBases?.length > 0) {
        serviceChargeBases?.forEach((item, index) => {
          if (['', null, 'null', undefined, 'undefined'].includes(item.chargebasis_id)) {
            errors[`chargebasis_id_${index}`] = EMPTY_SERVICE_CHARGE_BASIS_ERROR;
          }

          if (item?.basistypes_id == 1) {

            if (['', null, 'null', undefined, 'undefined'].includes(item.price_rate)) {
              errors[`price_rate_${index}`] = EMPTY_SERVICE_PRICE_RATE_ERROR;
            }
            if (['', null, 'null', undefined, 'undefined'].includes(item.min_base_price)) {
              errors[`min_base_price_${index}`] = EMPTY_SERVICE_MIN_BASE_PRICE_ERROR;
            }

            if (hasBasisType5 == false) {
              if (!['', null, 'null', undefined, 'undefined'].includes(item.rate_cutoff) && ['', null, 'null', undefined, 'undefined'].includes(item.add_on_price)) {
                errors[`add_on_price_${index}`] = EMPTY_ADD_ON_PRICE;
              }
            }


          } else if (item?.basistypes_id == 2) {
            if (item.price_rate === "" || item.price_rate === undefined) {
              errors[`price_rate_${index}`] = EMPTY_SERVICE_PRICE_RATE_ERROR;
            }
          } else if (item?.basistypes_id == 3 || item?.basistypes_id == 4) {
            if (item?.chargetypes.length === 0) {
              errors[`chargetypes_${index}`] = EMPTY_SERVICE_CHARGE_TYPE_ERROR;
            }
            item?.chargetypes.forEach((item1, index1) => {
              if (
                item1.chargetype_rule_value === "" ||
                item1.chargetype_rule_value === undefined
              ) {
                errors[`chargetypes_${index}_${index1}`] =
                  EMPTY_SERVICE_CHARGE_TYPE_ERROR;
              }
            });
          } else if (item?.basistypes_id == 5) {
            if (
              (item.incremental_price === "" ||
                item.incremental_price === undefined) &&
              item.incremental_price_status == 1
            ) {
              errors[`incremental_price_${index}`] =
                EMPTY_SERVICE_INCREMENTAL_RULE_ERROR;
            }
            if (
              item.min_base_price === "" ||
              item.min_base_price === undefined
            ) {
              errors[`min_base_price_${index}`] =
                EMPTY_SERVICE_MIN_BASE_PRICE_ERROR;
            }
          }
        });
      }
      if (
        (!formik.values.default_chargebasis_id ||
          formik.values.default_chargebasis_id == "null") &&
        formik.values.custom_rule === "0" &&
        CheckValidArrayLength(serviceChargeBases, [4, 5]) > 0
      ) {
        errors.default_chargebasis_id = EMPTY_SERVICE_DEFAULT_CHARG_BASIS;
      }

     
      // console.log("formik.values.default_chargebasis_id", formik.values.default_chargebasis_id);
      // console.log("serviceChargeBases", serviceChargeBases);
      // console.log("values.custom_rule", formik.values.custom_rule);
      
      if(formik.values.custom_rule === "0" && !['', null, 'null', undefined, 'undefined'].includes(formik.values.default_chargebasis_id)){
        let isExistCharbasisId = serviceChargeBases?.find((item) => Number(item?.chargebasis_id) === Number(formik.values.default_chargebasis_id));
        // console.log("isExistCharbasisId", isExistCharbasisId);
        if(isExistCharbasisId == undefined){
          formik.values.default_chargebasis_id = null;
          errors.default_chargebasis_id = EMPTY_SERVICE_DEFAULT_CHARG_BASIS;
        }
      }

      if(formik.values.custom_rule === "1"){
        let isExistCharbasisId = serviceChargeBases?.find((item) => Number(item?.chargebasis_id) === Number(formik.values.default_chargebasis_id));

        if(isExistCharbasisId == undefined){
          formik.values.default_chargebasis_id = null;
        }else{
          formik.values.default_chargebasis_id = isExistCharbasisId.chargebasis_id;
        }
      }
      
      
      //console.log("errors", errors);


      // if (errors) {
      //   ScrollToViewFirstError(errors);
      // }

      return errors;
    },
    onSubmit: (values) => {
      if (CheckValidArrayLength(serviceChargeBases, [1, 2, 3, 5]) == 1) {
        Swal.fire({
          icon: "error",
          title: "Error",
          text: EMPTY_CHARGE_BASIS,
        });
        return;
      }
      if (
        serviceChargeBases?.some((item) => item?.basistypes_id === 5) &&
        !hasMinimumTwoValidIds(serviceChargeBases, 2)
      ) {
        Swal.fire({
          icon: "error",
          title: "Error",
          text: EMPTY_CHARGE_BASIS,
        });
        return;
      }


      if (serviceChargeBases.filter((item) => item?.basistypes_id == 4).length > 0) {
        if (
          !serviceChargeBases.filter(
            (item) => item?.basistypes_id != 4 && item?.basistypes_id != 2
          )?.length > 0
        ) {
          Swal.fire({
            icon: "error",
            title: "Error",
            text: EMPTY_CHARGE_BASIS_ONE,
          });
          return;
        }
      }
     

      
      const payload = {
        id: location.state.id,
        agent_id: agent_id,
        name: values.name,
        servicetype_id: values.serviceType,
        description: values.description,
        benefits: values.benefits,
        vat_exempt: values.vat_exempt ? "1" : "0",
        default_chargebasis_status:
          values.default_chargebasis_id == null ||
            values.default_chargebasis_id == "null"
            ? "0"
            : "1",
        default_chargebasis_id: values.default_chargebasis_id,
        chargebasis_dependent_other: values.chargebasis_dependent_other
          ? "1"
          : "0",
        incremental_rule: values.incremental_rule,
        custom_rule: values.custom_rule,
        status: values.status,
        servicechargebases: hasMinimumTwoValidIds(serviceChargeBases, 1)
          ? serviceChargeBases
          : [],
        frequency_status: values.frequency_status,
        frequency_optional_chargebasis_id: values.frequency_optional_chargebasis_id,
        link_frequency_rule: values.link_frequency_rule,
      };


      


     // console.log("Payload:", JSON.stringify(payload, null, 2));

     // return


      dispatch(updateService(payload))
        .unwrap()
        .then((res) => {
          if (res.status) {
            Swal.fire({
              icon: "success",
              title: "Success",
              text: res.msg,
              timer: 3000,
            }).then(() => {
              window.location.href = "/#/admin/pricing/all-services";
            });
          } else {
            Swal.fire({
              icon: "error",
              title: "Error",
              text: res.msg,
            });
          }
        })
        .catch((err) => {
          Swal.fire({
            icon: "error",
            title: "Error",
            text: err.msg,
          });
        });
    },
  });

  useEffect(() => {
    if (textareaRef.current) {
      textareaRef.current.style.height = "auto";
      textareaRef.current.style.height =
        textareaRef.current.scrollHeight + "px";
    }
  }, [formik.values.description]);


  useEffect(() => {
    if (textareaRefBenefits.current) {
      textareaRefBenefits.current.style.height = "auto";
      textareaRefBenefits.current.style.height =
        textareaRefBenefits.current.scrollHeight + "px";
    }
  }, [formik.values.benefits]);


  const GetServiceDataById = async () => {
    let Res = await dispatch(
      GetserviceByIdApi({
        agent_id: agent_id,
        id: location.state.id,
      })
    ).unwrap();

    if (Res.status) {
      if (Res.data) {
        const {
          vat_exempt,
          status,
          servicetype_id,
          name,
          incremental_rule,
          id,
          frequency_status,
          frequency_optional_chargebasis_id,
          description,
          default_chargebasis_status,
          default_chargebasis_id,
          custom_rule,
          chargebasis_dependent_other,
          benefits,
          agent_id,
          ServiceType,
          servicechargebases,
          link_frequency_rule,
          isUsed
        } = Res.data;
        setIsUsedService(isUsed || false);
        formik.setFieldValue("name", name || "");
        formik.setFieldValue("serviceType", servicetype_id || "");
        formik.setFieldValue("description", description || "");
        formik.setFieldValue("benefits", benefits || "");
        formik.setFieldValue("vat_exempt", vat_exempt == "1" ? true : false);
        formik.setFieldValue("status", status || "1");
        formik.setFieldValue("custom_rule", custom_rule || "0");
        formik.setFieldValue("incremental_rule", incremental_rule || "0");
        formik.setFieldValue(
          "default_chargebasis_id",
          default_chargebasis_id || null
        );
        formik.setFieldValue(
          "chargebasis_dependent_other",
          chargebasis_dependent_other || "0"
        );
        formik.setFieldValue(
          "default_chargebasis_status",
          default_chargebasis_status || "0"
        );
        formik.setFieldValue("frequency_status", frequency_status || "0");
        formik.setFieldValue(
          "frequency_optional_chargebasis_id",
          frequency_optional_chargebasis_id || null
        );
        formik.setFieldValue("link_frequency_rule", link_frequency_rule || "0");
        formik.setFieldValue("agent_id", agent_id || null);
        formik.setFieldValue("id", id || null);
        formik.setFieldValue("ServiceType", ServiceType || null);

        let newServiceChargeBases = servicechargebases?.map((item) => {

          return {
            chargebasis_id: item?.chargebasis_id || null,
            price_rate: item?.price_rate || null,
            min_base_price: item?.min_base_price || null,
            incremental_price: item?.incremental_price || null,
            chargebasis_asc_order: item?.chargebasis_asc_order || null,
            operator: item?.operator || "+",
            rate_cutoff: item?.rate_cutoff || null,
            add_on_price: item?.add_on_price || null,
            chargetypes: item?.chargetypes || [],
            name: item?.name || null,
            servicechargebases_id: item?.servicechargebases_id || null,
            basistypes_id: item?.basistypes_id || null,
          };
        });
        setServiceChargeBases(newServiceChargeBases || []);
        setIsFormInitialized(true);
        setTimeout(() => {
          formik.validateForm();
        }, 100);
      }
    } else {
      Swal.fire({
        icon: "error",
        title: "Error",
        text: Res.msg,
      });
    }
  };

  const handleChargeBasisChange = (index, field, e, charge, type) => {
    let value = e.target.value;


    // console.log("index", index)
    // console.log("value", value)
    // console.log("field", field)
    // console.log("charge", charge)
    // console.log("type", type)


    const regex = /^[0-9]*\.?[0-9]*$/;

    const numericFields = ["price_rate", "min_base_price", "incremental_price", "add_on_price"];
    if (numericFields.includes(field) && !regex.test(value)) {
      value = value.replace(/[^0-9.]/g, "");
    }

    const integerOnlyFields = ["rate_cutoff"];
    if (integerOnlyFields.includes(field) && value) {
      value = value.replace(/[^0-9]/g, ""); // Allow only integers
    }

    const updated = [...serviceChargeBases];

    if (type == "f") {
      index = updated.findIndex((item) => item.basistypes_id === 4);
    }
    updated[index][field] = value;

    formik.errors[`${field}_${index}`] = ""; // Clear the error for the specific field

    setServiceChargeBases(updated);
  };

  const handleChargeBasisSelect = (index, field, e, charge) => {
    let value = e.target.value;
    const regex = /^[0-9]*\.?[0-9]*$/;
    // Allow only numbers and decimals for certain fields
    const numericFields = ["price_rate", "min_base_price", "incremental_price"];
    if (numericFields.includes(field) && !regex.test(value)) {
      value = value.replace(/[^0-9.]/g, "");
    }


    if (serviceChargeBases.length == 1 && [1, 2, 3].includes(charge?.basistypes_id)) {
      formik.setFieldValue("default_chargebasis_id", value);
    }

    const updated = [...serviceChargeBases];

    updated[index].chargetypes = [];
    updated[index].price_rate = "";
    updated[index].incremental_price = "";

    updated[index][field] = value;
    updated[index].basistypes_id = charge?.basistypes_id || null;
    updated[index].chargebasis_asc_order = index + 1 || null;

    formik.errors[`${field}_${index}`] = ""; // Clear the error for the specific field
    formik.errors[`chargebasis_id_${index}`] = ""; // Clear the error for chargebasis_id

    if (charge?.basistypes_id == 5) {
      updated[index].incremental_price =
        charge?.incremental_price || null;
    }

    if (charge) {
      // Special logic for basis type 4
      const currentBasisType = updated[index]?.basistypes_id;
      const newBasisType = charge?.basistypes_id;

      updated[index].basistypes_id = newBasisType || null;
      updated[index].name = charge?.name || null;

      if (charge?.basistypes_id == 4) {

        


        const selectedChargeBasis = serviceChargeBases?.find(
          (item) => item?.basistypes_id !== 4 || item?.basistypes_id !== 2
        );
        formik.setFieldValue(
          "frequency_optional_chargebasis_id",
          selectedChargeBasis?.chargebasis_id
        );
      }

      if (currentBasisType === 4 && newBasisType !== 4) {
        const basisType4Items = updated.filter(
          (item) => item?.basistypes_id === 4
        );
        updated[index].chargetypes = [];

        if (basisType4Items.length === 1) {
          formik.setFieldValue("custom_rule", "0");
        }
      }

      if (currentBasisType === 3 && newBasisType !== 3) {
        updated[index].chargetypes = [];
      }

      if (newBasisType === 4) {
        formik.setFieldValue("custom_rule", "1");
      }

      if (newBasisType === 3 || newBasisType === 4) {
        updated[index].chargetypes = charge?.ChargeTypes || [];
      }
      if (newBasisType == 5) {
        formik.setFieldValue("incremental_rule", "1");
      }
    } else {
      updated[index].chargetypes = charge?.ChargeTypes || [];
      updated[index].basistypes_id = null;
      updated[index].name = null;
    }

    CheckConditions(updated);
    setServiceChargeBases(updated);

   
   if(Number(formik.values.frequency_status) === 1){
      let existCharbasis =updated?.find((item) => Number(item?.chargebasis_id) === Number(formik.values.frequency_optional_chargebasis_id))
      if(existCharbasis == undefined){
       formik.setFieldValue(
          "frequency_optional_chargebasis_id",value
        );
      }
   }


  };

  const addChargeBasis = () => {
    setServiceChargeBases((prev) => [
      ...prev,
      {
        chargebasis_id: null,
        price_rate: null,
        min_base_price: null,
        incremental_price: null,
        chargebasis_asc_order: null,
        operator: "+",
        chargetypes: [],
        rate_cutoff: null,
        add_on_price: null,
      },
    ]);
  };

  const removeChargeBasis = (index) => {
    Swal.fire({
      title: "Are you sure?",
      text: "You won't be able to revert this!",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Yes, delete it!",
    }).then((result) => {
      if (result.isConfirmed) {
        const updated = [...serviceChargeBases];
        updated.splice(index, 1);

        setServiceChargeBases(updated);

        // new code phase 2 start
        if (!['', null, 'null', undefined, 'undefined'].includes(formik.values.frequency_optional_chargebasis_id)) {
          const exists = updated.some(
            item => parseInt(item.chargebasis_id) === parseInt(formik.values.frequency_optional_chargebasis_id)
          );
          if (exists) {
            //console.log("Item exists — no action needed.");
          } else {
            const result = updated
              .filter(item => item.basistypes_id !== 4 && item.basistypes_id !== 2)
              .map(item => parseInt(item.chargebasis_id));
            if (result.length > 0) {
              formik.setFieldValue("frequency_optional_chargebasis_id", (result[0]).toString());
            } else {
              formik.setFieldValue("frequency_optional_chargebasis_id", null);
            }

          }
        }

        if (updated.length > 0 && !updated?.find(item => Number(item?.basistypes_id) === 4)) {
          formik.setFieldValue("frequency_status", "0");
          formik.setFieldValue("frequency_optional_chargebasis_id", null);
          formik.setFieldValue("custom_rule", "0");
        }

        // end new code phase 2 



        // if (updated.length > 0 && updated.some((item) => item?.basistypes_id != 4)) {
        //   formik.setFieldValue("frequency_status", "0");
        //   formik.setFieldValue("frequency_optional_chargebasis_id", null);
        //   formik.setFieldValue("custom_rule", "0");
        // }

        if (updated.length == 1) {
          formik.setFieldValue("chargebasis_dependent_other", "0");
          formik.setFieldValue("custom_rule", "0");
        }
      }
    });
  };

  const handleChargeTypesChange = (index, name, e, data) => {
    let value = e.target.value;
    const regex = /^[0-9]*\.?[0-9]*$/;

    if (!regex.test(value)) {
      value = value.replace(/[^0-9.]/g, null);
    }

    // Deep clone to avoid mutating read-only objects
    const updated = serviceChargeBases.map((item) => ({
      ...item,
      chargetypes: item.chargetypes
        ? item.chargetypes.map((ct) => ({ ...ct }))
        : [],
    }));

    if (data.servicechargebasisvalues_id != undefined) {
      const existingIndex = updated[index].chargetypes.findIndex(
        (ct) =>
          ct?.servicechargebasisvalues_id === data.servicechargebasisvalues_id
      );

      if (existingIndex > -1) {
        updated[index].chargetypes[existingIndex].chargetype_rule_value = value;
        updated[index].chargetypes[existingIndex].chargetype_rule_id =
          data.chargetype_rule_id;
        formik.errors[`chargetypes_${index}_${existingIndex}`] = "";
      } else {
        updated[index].chargetypes.push({
          chargetype_rule_id: data.chargetype_rule_id,
          chargetype_rule_value: value,
        });
      }

      setServiceChargeBases(updated);
    } else {
      const existingIndex = updated[index].chargetypes.findIndex(
        (ct) => ct?.chargetype_rule_id === data.id || ct?.id === data.id
      );

      if (existingIndex > -1) {
        updated[index].chargetypes[existingIndex].chargetype_rule_value = value;
        updated[index].chargetypes[existingIndex].chargetype_rule_id = data.id;

        formik.errors[`chargetypes_${index}_${existingIndex}`] = "";
      } else {
        updated[index].chargetypes.push({
          chargetype_rule_id: data.id,
          chargetype_rule_value: value,
        });
      }

      setServiceChargeBases(updated);
    }

    // setServiceChargeBases(updated);
  };

  const CheckConditions = (updated) => {
    if (updated.length > 0) {
      const NotExistingBasisType_5 = updated.some(
        (item) => item?.basistypes_id == 5
      );

      if (NotExistingBasisType_5) {
        formik.setFieldValue("incremental_rule", "1");
      } else {
        formik.setFieldValue("incremental_rule", "0");
      }

      const NotExistingBasisType_4 = updated.some(
        (item) => item?.basistypes_id == 4
      );
      if (NotExistingBasisType_4) {
        formik.setFieldValue("frequency_status", "1");
        formik.setFieldValue("default_chargebasis_id", null);
        formik.setFieldValue("chargebasis_dependent_other", "0");
      } else {
        formik.setFieldValue("frequency_status", "0");
        formik.setFieldValue("frequency_optional_chargebasis_id", null);
        formik.setFieldValue("custom_rule", "0");
      }
      if (updated.length > 1 && NotExistingBasisType_4) {
        formik.setFieldValue("custom_rule", "1");
      }
    }
  };

  return (
    <div>
      <div className="row mb-4">
        <div className="col">
          <h4 className="page-title">
            <Link to="/admin/pricing/all-services">
              <i className="bx bx-arrow-back text-pink pe-2"></i>
            </Link>
            Edit Service
          </h4>
        </div>
      </div>

      <div className="card form-card">
        <div className="card-header d-sm-flex justify-content-between align-items-center">
          <div>
            <h5 className="card-title mb-0">Edit Service</h5>
          </div>

          <div className="">
            <div className="d-flex justify-content-sm-center  justify-content-lg-start align-items-center">
              <label htmlFor="status" className=" col-form-label py-0">
                Status:
              </label>

              <div className="form-switch ms-2">
                <input
                  //disabled={location.state?.deleted == false ? true : false}
                  disabled={isUsedService}
                  className="form-check-input"
                  type="checkbox"
                  role="switch"
                  id="status"
                  name="status"
                  checked={formik.values.status === "1"}
                  onChange={(e) => {
                    formik.setFieldValue(
                      "status",
                      e.target.checked ? "1" : "0"
                    );
                  }}
                />
              </div>
            </div>
          </div>
        </div>
        <div className="card-body px-0 px-lg-3">
          <div className="">
            <div className="row">
              <div className="col-md-6 mb-3">
                <div className="row justify-content-sm-center  justify-content-lg-start">
                  <label className="col-form-label col-sm-4" htmlFor="name">
                    Name of Service:
                  </label>
                  <div className="col-sm-8">
                    <input
                      type="text"
                      className="form-control"
                      id="name"
                      name="name"
                      placeholder="Enter Name of Service"
                      value={formik.values.name}
                      onChange={formik.handleChange}
                    />
                    {formik.errors.name && (
                      <div className="text-pink error-text">
                        {formik.errors.name}
                      </div>
                    )}
                  </div>
                </div>
              </div>
              <div className="col-md-6 mb-3">
                <div className="row justify-content-sm-center  justify-content-lg-start">
                  <label
                    className="col-form-label col-sm-4"
                    htmlFor="serviceType"
                  >
                    Service Type:
                  </label>

                  <div className="col-sm-8">
                    <select
                      className="form-select"
                      id="serviceType"
                      name="serviceType"
                      value={formik.values.serviceType}
                      onChange={formik.handleChange}
                      disabled={location.state?.deleted == false ? true : false}
                    >
                      <option value="">Select Service Type</option>
                      {serviceTypeData.map((item) => (
                        <option key={item.id} value={item.id}>
                          {item.name}
                        </option>
                      ))}
                    </select>
                    {formik.errors.serviceType && (
                      <div className="text-pink error-text">
                        {formik.errors.serviceType}
                      </div>
                    )}
                  </div>
                </div>
              </div>
              <div className="col-md-6 mb-3">
                <div className="row justify-content-sm-center  justify-content-lg-start">
                  <label
                    className="col-form-label col-sm-4"
                    htmlFor="description"
                  >
                    Description:
                  </label>
                  <div className="col-sm-8">
                    <textarea
                      // rows={4}
                      ref={textareaRef}
                      className="form-control"
                      id="description"
                      name="description"
                      placeholder="Enter Description"
                      value={formik.values.description}
                      onChange={formik.handleChange}
                      style={{
                        width: "100%",
                        minHeight: "40px",
                        maxHeight: "300px",
                        overflowY: "hidden",
                        padding: "8px",
                        fontSize: "16px",
                        borderRadius: "5px",
                        border: "1px solid #ccc",
                      }}
                    />
                    {formik.errors.description && (
                      <div className="text-pink error-text">
                        {formik.errors.description}
                      </div>
                    )}
                  </div>
                </div>
              </div>
              <div className="col-md-6 mb-3">
                <div className="row justify-content-sm-center  justify-content-lg-start">
                  <label className="col-form-label col-sm-4" htmlFor="benefits">
                    Benefits:
                  </label>
                  <div className="col-sm-8">
                    <textarea
                      // rows={4}
                      ref={textareaRefBenefits}
                      className="form-control"
                      id="benefits"
                      name="benefits"
                      placeholder="Enter Benefits"
                      value={formik.values.benefits}
                      onChange={formik.handleChange}
                      style={{
                        width: "100%",
                        minHeight: "40px",
                        maxHeight: "300px",
                        overflowY: "hidden",
                        padding: "8px",
                        fontSize: "16px",
                        borderRadius: "5px",
                        border: "1px solid #ccc",
                      }}
                    />
                    {formik.errors.benefits && (
                      <div className="text-pink error-text-text">
                        {formik.errors.benefits}
                      </div>
                    )}
                  </div>
                </div>
              </div>


              {
                agentData && agentData?.vat_registered == "YES" ? (
                  <>
                    <div className="col-md-6 mb-3">
                      <div className="row justify-content-sm-center  justify-content-lg-start align-items-center">
                        <label
                          className="col-form-label form-check-label col-sm-4"
                          htmlFor="vat_exempt"
                        >
                          VAT Exempt:
                        </label>
                        <div className="col-sm-8">
                          <div className="form-check ps-0">
                            <input
                              type="checkbox"
                              className="form-check-input ms-2"
                              id="vat_exempt"
                              name="vat_exempt"
                              checked={formik.values.vat_exempt}
                              onChange={formik.handleChange}
                            />
                            {formik.errors.vat_exempt && (
                              <div className="text-pink error-text-text">
                                {formik.errors.vat_exempt}
                              </div>
                            )}
                          </div>
                        </div>
                      </div>
                    </div>
                  </>
                ) :
                  ""
              }





              <div className="row mt-4 ">
                <div className="gray-card">
                  {serviceChargeBases &&
                    serviceChargeBases.map((charge, index) => (
                      <div className="row py-2">
                        <div className="col-md-5">
                          <div className="row justify-content-sm-center  justify-content-lg-start">
                            <label
                              className="col-form-label py-0 col-sm-4"
                              htmlFor="numberOfServices"
                            >
                              Charge basis:
                            </label>
                            <div className=" col-sm-8">
                              <select
                                className="form-select"
                                value={charge?.chargebasis_id}
                                onChange={(e) => {
                                  const selectedId = e.target.value;
                                  const selectedItem = chargeBases.find(
                                    (item) => item.id == selectedId
                                  );
                                  handleChargeBasisSelect(
                                    index,
                                    "chargebasis_id",
                                    e,
                                    selectedItem
                                  );
                                }}
                              >
                                <option value="null">
                                  Select Charge basis
                                </option>

                                {

                                  chargeBases.map((cbItem, i) => {
                                    if (isUsedService == true && cbItem.BasisType?.id === 2) {
                                      return null;
                                    }

                                    const isAlreadySelected =
                                      serviceChargeBases.some(
                                        (scItem, scIndex) =>
                                          scItem.chargebasis_id == cbItem.id &&
                                          scIndex !== index
                                      );



                                    if (isAlreadySelected) {
                                      return null; // Skip rendering this item
                                    }

                                    /* SELF ASSIGMENT CONDITIONS */
                                    let isBasisTypeId_5 = serviceChargeBases.some(
                                      (scItem, scIndex) =>
                                        scItem?.basistypes_id == 5
                                    );

                                    if (isBasisTypeId_5) {
                                      if (
                                        cbItem?.BasisType?.id == 2 ||
                                        cbItem?.BasisType?.id == 3 ||
                                        cbItem?.BasisType?.id == 4
                                      ) {
                                        return null;
                                      }
                                      if (
                                        cbItem?.BasisType?.id == 1 &&
                                        cbItem?.self_assessment == 0
                                      ) {
                                        return null;
                                      }
                                    }

                                    let isBasisTypeId_2_3_4 =
                                      serviceChargeBases.some(
                                        (scItem, scIndex) =>
                                          scItem?.basistypes_id == 2 ||
                                          scItem?.basistypes_id == 3 ||
                                          scItem?.basistypes_id == 4 ||
                                          (scItem?.basistypes_id == 1 &&
                                            cbItem?.self_assessment == 0)
                                      );
                                    if (isBasisTypeId_2_3_4) {
                                      if (cbItem?.BasisType?.id == 5) {
                                        return null;
                                      }
                                    }

                                    let isBasisTypeID_4 =
                                      serviceChargeBases.filter(
                                        (scItem, scIndex) =>
                                          scItem?.basistypes_id == 4
                                      );

                                    if (isBasisTypeID_4.length > 0) {
                                      if (
                                        charge?.chargebasis_id != cbItem.id &&
                                        cbItem?.BasisType?.id == 4
                                      ) {
                                        return null;
                                      }
                                    }

                                    return (
                                      <option value={cbItem.id} key={cbItem.id}>
                                        {`${cbItem?.name} (${cbItem?.BasisType?.name || ""
                                          })`}
                                      </option>
                                    );
                                  })}
                              </select>

                              {formik.errors[`chargebasis_id_${index}`] && (
                                <div
                                  id={`chargebasis_id_${index}`}
                                  className="error-text text-pink"
                                >
                                  {formik.errors[`chargebasis_id_${index}`]}
                                </div>
                              )}
                            </div>
                          </div>
                        </div>
                        <div className="col-md-6">
                          <div className="row">
                            <div className="col-md-6">
                              <div className="col-md-12">
                                {charge.basistypes_id == 3 ||
                                  charge.basistypes_id == 4 ? (
                                  <>
                                    {charge.chargetypes?.map((item1, index1) => (
                                      <div className="row">
                                        <label className="col-sm-4  col-form-label py-0 mt-1">
                                          {item1.name}:
                                        </label>
                                        <div className="col-12 col-md-8  ">
                                          <div className="input-group mb-2">
                                            <span className="input-group-text">
                                              £
                                            </span>
                                            <input
                                              type="text"
                                              className="form-control"
                                              name={item1.name}
                                              placeholder={`Enter ${item1.name} price`}
                                              value={
                                                item1.chargetype_rule_value || ""
                                              }
                                              onChange={(e) =>
                                                handleChargeTypesChange(
                                                  index,
                                                  "chargetypes",
                                                  e,
                                                  item1
                                                )
                                              }
                                            />

                                          </div>
                                          {formik.errors[
                                            `chargetypes_${index}_${index1}`
                                          ] && (
                                              <div
                                                id={`chargetypes_${index}_${index1}`}
                                                className="error-text text-pink "
                                              >
                                                {
                                                  formik.errors[
                                                  `chargetypes_${index}_${index1}`
                                                  ]
                                                }
                                              </div>
                                            )}
                                        </div>
                                      </div>
                                    ))}
                                  </>
                                ) : (
                                  <>
                                    {charge.incremental_price_status == 0 &&
                                      charge.basistypes_id == 5 ? (
                                      <></>
                                    ) : (
                                      <div className="row">
                                        <label className="col-sm-4  col-form-label py-0 mt-1">
                                          {charge.basistypes_id == 1
                                            ? "Per Unit Rate:"
                                            : charge.basistypes_id == 2
                                              ? "Per Hour Rate:"
                                              : charge.basistypes_id == 5
                                                ? "Incremental Price:"
                                                : "Per Unit Rate:"}
                                        </label>
                                        <div className="col-12 col-md-8  ">
                                          {charge.basistypes_id == 5 ? (
                                            <div className="input-group mb-2">
                                              <span className="input-group-text">
                                                £
                                              </span>
                                              <input
                                                type="text"
                                                className="form-control "
                                                placeholder="Enter Price"
                                                name="incremental_price"
                                                value={charge.incremental_price}
                                                onChange={(e) =>
                                                  handleChargeBasisChange(
                                                    index,
                                                    "incremental_price",
                                                    e
                                                  )
                                                }
                                              />
                                            </div>
                                          ) : (
                                            <div className="input-group mb-2">
                                              <span className="input-group-text">
                                                £
                                              </span>
                                              <input
                                                type="text"
                                                className="form-control "
                                                placeholder="Enter Price"
                                                name="price_rate"
                                                value={charge.price_rate}
                                                onChange={(e) =>
                                                  handleChargeBasisChange(
                                                    index,
                                                    "price_rate",
                                                    e
                                                  )
                                                }
                                              />
                                            </div>
                                          )}
                                          {formik.errors[`price_rate_${index}`] && (
                                            <div
                                              className="error-text text-pink"
                                              id={`price_rate_${index}`}
                                            >
                                              {formik.errors[`price_rate_${index}`]}
                                            </div>
                                          )}
                                          {formik.errors[
                                            `incremental_price_${index}`
                                          ] && (
                                              <div
                                                id={`incremental_price_${index}`}
                                                className="error-text text-pink"
                                              >
                                                {
                                                  formik.errors[
                                                  `incremental_price_${index}`
                                                  ]
                                                }
                                              </div>
                                            )}
                                        </div>



                                      </div>
                                    )}
                                  </>
                                )}


                              </div>

                            </div>
                            <div className="col-md-6">


                              <div className="col-md-12 ">
                                <div className="row">
                                  {charge.basistypes_id == 2 ||
                                    charge.basistypes_id == 3 ||
                                    charge.basistypes_id == 4 ? (
                                    ""
                                  ) : (
                                    <>
                                      <label className="col-sm-4  col-form-label py-0 mt-1">
                                        Min Base Price:
                                      </label>
                                      <div className="col-12 col-md-8  ">
                                        <div className="input-group">
                                          <span className="input-group-text">£</span>
                                          <input
                                            type="text"
                                            className="form-control "
                                            placeholder="Enter Price"
                                            value={charge.min_base_price}
                                            onChange={(e) =>
                                              handleChargeBasisChange(
                                                index,
                                                "min_base_price",
                                                e
                                              )
                                            }
                                          />

                                        </div>
                                        {formik.errors[
                                          `min_base_price_${index}`
                                        ] && (
                                            <div
                                              className="error-text text-pink "
                                              id={`min_base_price_${index}`}
                                            >
                                              {
                                                formik.errors[
                                                `min_base_price_${index}`
                                                ]
                                              }
                                            </div>
                                          )}
                                      </div>
                                    </>
                                  )}
                                </div>



                              </div>

                            </div>
                          </div>
                          <div className="row">
                            <div className="col-md-6">

                              {

                                charge.basistypes_id == 1 && hasBasisType5 == false ?
                                  <div className="row">
                                    <label className="col-sm-4  col-form-label py-0 mt-1">
                                      Rate Cut Off:
                                    </label>
                                    <div className="col-12 col-md-8  ">
                                      <div className=" mb-2">
                                        <input
                                          type="text"
                                          className="form-control"
                                          placeholder="Enter Rate Cut Off"
                                          name={"rate_cutoff"}
                                          value={charge.rate_cutoff}
                                          onChange={(e) =>
                                            handleChargeBasisChange(
                                              index,
                                              "rate_cutoff",
                                              e
                                            )
                                          }
                                        />
                                      </div>
                                    </div>
                                  </div>
                                  : ""
                              }
                            </div>
                            <div className="col-md-6">



                              {

                                // Add Add On Price for basis type 1
                                charge.basistypes_id == 1 && hasBasisType5 == false ?
                                  <div className="row">
                                    <label className="col-sm-4  col-form-label py-0 mt-1">
                                      Add On Price:
                                    </label>
                                    <div className="col-12 col-md-8  ">
                                      <div className="input-group mb-2">
                                        <span className="input-group-text">
                                          £
                                        </span>
                                        <input
                                          type="text"
                                          className="form-control"
                                          placeholder="Enter Add On Price"
                                          name={"add_on_price"}
                                          value={charge.add_on_price}
                                          onChange={(e) =>
                                            handleChargeBasisChange(
                                              index,
                                              "add_on_price",
                                              e
                                            )
                                          }
                                        />
                                      </div>
                                      <div>
                                        {formik.errors[`add_on_price_${index}`] && (
                                          <div
                                            className="text-pink error-text mb-0"
                                            id={`add_on_price_${index}`}
                                          >
                                            {formik.errors[`add_on_price_${index}`]}
                                          </div>
                                        )}
                                      </div>
                                    </div>


                                  </div>
                                  : ""
                              }
                            </div>
                          </div>
                        </div>





                        <div className="col-md-1 ps-0">
                          <button
                            className="btn btn-plus p-0 w-25 border-0 "
                            style={{ lineHeight: "25px" }}
                          >
                            {index === serviceChargeBases.length - 1 ? (
                              <>
                                {serviceChargeBases.length != 1  && (

                                  <i
                                    className="fa-regular fa-circle-minus fs-2 text-pink plusMinus-circle"
                                    onClick={() => removeChargeBasis(index)}
                                  ></i>
                                )}

                                <i
                                  className="fa-regular fa-circle-plus mt-1 fs-2 text-pink plusMinus-circle "
                                  onClick={addChargeBasis}
                                >
                                  {" "}
                                </i>
                              </>
                            ) : (
                              <>
                                
                                  <i
                                    className="fa-regular fa-circle-minus fs-2 text-pink plusMinus-circle"
                                    onClick={() => removeChargeBasis(index)}
                                  ></i>
                              

                              </>

                            )}
                          </button>
                        </div>
                      </div>
                    ))}
                </div>
              </div>

              {hasMinimumTwoValidIds(serviceChargeBases, 1) &&
                serviceChargeBases?.every(
                  (item) => item?.basistypes_id !== 5
                ) &&
                serviceChargeBases?.every(
                  (item) => item?.basistypes_id !== 4
                ) && (
                  <div className="row mt-4" key={1}>
                    <div className="gray-card">
                      <div className="row align-items-center py-2">
                        <div className="col-md-5">
                          <div className="row justify-content-sm-center justify-content-lg-start">
                            <label
                              className="col-form-label py-0 col-sm-4"
                              htmlFor="numberOfServices"
                            >
                              Default Charge Basis
                            </label>
                            <div className="col-sm-8">
                              <select
                                className="form-select"
                                name="default_chargebasis_id"
                                value={formik.values.default_chargebasis_id}
                                onChange={formik.handleChange}
                              >
                                <option value="null">
                                  Select Default Charge Basis
                                </option>
                                {serviceChargeBases
                                  .filter(
                                    (opt) =>
                                      opt?.chargebasis_id !== null &&
                                      opt?.chargebasis_id !== "null" &&
                                      opt?.chargebasis_id !== "" &&
                                      opt?.chargebasis_id !== undefined &&
                                      opt?.chargebasis_id !== "undefined"
                                  )
                                  .map((opt, idx) => (
                                    <option
                                      value={opt.chargebasis_id}
                                      key={idx}
                                    >
                                      {opt?.name}
                                    </option>
                                  ))}
                              </select>

                              {(!formik.values.default_chargebasis_id ||
                                formik.values.default_chargebasis_id ===
                                "null" ||
                                formik.values.default_chargebasis_id ===
                                null) &&
                                formik.values.custom_rule == "0" &&
                                CheckValidArrayLength(
                                  serviceChargeBases,
                                  [4, 5]
                                ) > 0 && (
                                  <div className="text-pink error-text-text">
                                    {EMPTY_SERVICE_DEFAULT_CHARG_BASIS}
                                  </div>
                                )}
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                )}

              {((hasMinimumTwoValidIds(serviceChargeBases, 2, 2) &&
                serviceChargeBases?.every(
                  (item) => item?.basistypes_id !== 5
                )) ||
                serviceChargeBases?.some(
                  (item) => item?.basistypes_id === 5
                )) && (
                  <div className="row mt-4">
                    <div className="gray-card">
                      <div className="card-header bg-transparent">
                        <h5 className="card-title">Pricing Rules</h5>
                      </div>

                      {/* Custom Pricing Rule */}
                      {hasMinimumTwoValidIds(serviceChargeBases, 2, 2) &&
                        serviceChargeBases?.every(
                          (item) => item?.basistypes_id !== 5
                        ) && (
                          <div className="d-flex mb-3 align-items-center">
                            <label className="col-form-label py-0 me-5">
                              Create a Custom Pricing rule?
                            </label>

                            {["1", "0"].map((val) => (
                              <div className="form-check ps-0 me-5" key={val}>
                                <input
                                  className="form-check-input"
                                  type="radio"
                                  name="custom_rule"
                                  id={`custom_rule_${val}`}
                                  value={val}
                                  checked={formik.values.custom_rule === val}
                                  onChange={() =>
                                    formik.setFieldValue("custom_rule", val)
                                  }
                                  disabled={serviceChargeBases?.some(
                                    (item) => item?.basistypes_id === 4
                                  )}
                                />
                                <label
                                  className="form-check-label"
                                  htmlFor={`custom_rule_${val}`}
                                >
                                  {val === "1" ? "Yes" : "No"}
                                </label>
                              </div>
                            ))}
                          </div>
                        )}


                      {/* Custom Pricing Rule Freqency Toggle Link frequency to all charge bases?*/}
                      {
                        serviceChargeBases?.some(item => item?.basistypes_id === 4)
                          ?
                          <div className="d-flex mb-3 align-items-center">
                            <label className="col-form-label py-0 me-3">
                              Link frequency to all charge bases?
                            </label>
                            {["1", "0"].map((val) => (
                              <div className="form-check me-3" key={val}>
                                <input
                                  className="form-check-input"
                                  type="radio"
                                  name="link_frequency_rule"
                                  id={`link_frequency_rule_${val}`}
                                  value={val}
                                  checked={formik.values.link_frequency_rule === val}
                                  onChange={() =>
                                    formik.setFieldValue("link_frequency_rule", val)
                                  }
                                // disabled={serviceChargeBases?.some(
                                //   (item) => item?.basistypes_id === 4
                                // )}
                                />
                                <label
                                  className="form-check-label"
                                  htmlFor={`link_frequency_rule_${val}`}
                                >
                                  {val === "1" ? "Yes" : "No"}
                                </label>
                              </div>
                            ))}
                          </div>
                          : ""
                      }

                      {/* Incremental Pricing Rule */}
                      {serviceChargeBases?.some(
                        (item) => item?.basistypes_id === 5
                      ) && (
                          <div className="d-flex mb-3 align-items-center">
                            <label className="col-form-label py-0 me-3">
                              Use Incremental pricing rule?
                            </label>

                            {["1", "0"].map((val) => (
                              <div className="form-check me-3" key={val}>
                                <input
                                  className="form-check-input"
                                  type="radio"
                                  name="incremental_rule"
                                  id={`incremental_rule_${val}`}
                                  value={val}
                                  checked={formik.values.incremental_rule === val}
                                  onChange={() =>
                                    formik.setFieldValue("incremental_rule", val)
                                  }
                                  disabled={serviceChargeBases?.some(
                                    (item) => item?.basistypes_id === 5
                                  )}
                                />
                                <label
                                  className="form-check-label"
                                  htmlFor={`incremental_rule_${val}`}
                                >
                                  {val === "1" ? "Yes" : "No"}
                                </label>
                              </div>
                            ))}
                          </div>
                        )}
                    </div>
                  </div>
                )}

              {formik.values.custom_rule == "1" &&
                hasMinimumTwoValidIds(serviceChargeBases, 2, 2) && (
                  <div className="row mt-4">
                    <div className="gray-card">
                      <div className="card-header bg-transparent">
                        <h5 className="card-title">Custom Pricing Rules</h5>
                      </div>

                      {serviceChargeBases?.every(
                        (item) => item?.basistypes_id !== 4
                      ) ? (
                        <div className="row">
                          <label className="col-form-label col-md-2 pt-0">
                            Pricing Rule
                          </label>
                          <div className="col-md-10  ">
                            <div className="row">
                              {serviceChargeBases &&
                                serviceChargeBases.map((item, index) => {
                                  if (
                                    item.chargebasis_id === "null" ||
                                    item.chargebasis_id === null ||
                                    item.chargebasis_id === "" ||
                                    item.chargebasis_id === undefined ||
                                    item.chargebasis_id === "undefined"
                                  ) {
                                    return null;
                                  }

                                  if (Number(item.basistypes_id) === 2) {
                                    return (
                                      <>
                                        {/* Optional: You can also return a comment or blank div */}
                                        <div className="col-md-2 my-2 d-none" />
                                      </>
                                    );
                                  }

                                  let checkIndex = 0;

                                  if (serviceChargeBases[0]?.basistypes_id === 2) {
                                    for (let i = 0; i < serviceChargeBases.length; i++) {
                                      if (serviceChargeBases[i]?.basistypes_id === 2) {
                                        checkIndex++;
                                      } else {
                                        break;
                                      }
                                    }
                                  }

                                  return (
                                    <>
                                      {index !== checkIndex ? (
                                        <>
                                          <div className="col-md-2 mb-2">
                                            <select
                                              className="form-select"
                                              value={item.operator}
                                              onChange={(e) =>
                                                handleChargeBasisChange(
                                                  index,
                                                  "operator",
                                                  e
                                                )
                                              }
                                            >
                                              <option value="+">+</option>
                                              <option value="*">*</option>
                                              <option value="/">/</option>
                                            </select>
                                          </div>
                                          <div className="col-md-2 mb-2">
                                            <input
                                              className="form-control"
                                              type="text"
                                              name={item?.name}
                                              value={item?.name}
                                              readOnly
                                            />
                                          </div>
                                        </>
                                      ) : (
                                        <>
                                          <div className="col-md-2 mb-2 ">
                                            <input
                                              className="form-control"
                                              type="text"
                                              name={item?.name}
                                              value={item?.name}
                                              readOnly
                                            />
                                          </div>
                                        </>
                                      )}
                                    </>
                                  );
                                })}
                            </div>
                          </div>
                        </div>
                      ) :


                        // add extar rule for frequency ...
                        formik.values.link_frequency_rule == "1" ? (
                          <div className="row">
                            <label className="col-form-label col-md-2 pt-0">
                              Pricing Rule
                            </label>
                            <div className="col-md-10  ">
                              <div className="row">
                                {serviceChargeBases &&
                                  serviceChargeBases
                                    // .filter((item) => Number(item.basistypes_id) !== 2)
                                    .map((item, index) => {
                                      if (
                                        item.chargebasis_id === "null" ||
                                        item.chargebasis_id === "" ||
                                        item.chargebasis_id === undefined
                                      ) {
                                        return null;
                                      }



                                      if (Number(item.basistypes_id) === 2) {
                                        return (
                                          <>
                                            {/* Optional: You can also return a comment or blank div */}
                                            <div className="col-md-2 my-2 d-none" />
                                          </>
                                        );
                                      }

                                      let checkIndex = 0;

                                      if (serviceChargeBases[0]?.basistypes_id === 2) {
                                        for (let i = 0; i < serviceChargeBases.length; i++) {
                                          if (serviceChargeBases[i]?.basistypes_id === 2) {
                                            checkIndex++;
                                          } else {
                                            break;
                                          }
                                        }
                                      }

                                      return (
                                        <>
                                          {index !== checkIndex ? (
                                            <>
                                              <div className="col-md-2 my-2">
                                                <select
                                                  className="form-select"
                                                  value={item.operator}
                                                  onChange={(e) =>
                                                    handleChargeBasisChange(
                                                      index,
                                                      "operator",
                                                      e
                                                    )
                                                  }
                                                >
                                                  <option value="+">+</option>
                                                  <option value="*">*</option>
                                                  <option value="/">/</option>
                                                </select>
                                              </div>
                                              <div className="col-md-2 my-2">
                                                <input
                                                  className="form-control"
                                                  type="text"
                                                  name={item.name}
                                                  value={item.name}
                                                  readOnly
                                                />
                                              </div>
                                            </>
                                          ) : (
                                            <>
                                              <div className="col-md-2 my-2 ">
                                                <input
                                                  className="form-control"
                                                  type="text"
                                                  name={item.name}
                                                  value={item.name}
                                                  readOnly
                                                />
                                              </div>
                                            </>
                                          )}
                                        </>
                                      );
                                    })}
                              </div>
                            </div>
                          </div>

                        )

                          :

                          (
                            <div className="row">
                              <label className="col-form-label col-md-2 pt-0">
                                Pricing Rule
                              </label>
                              <div className="col-md-10">
                                <div className="row">
                                  {/* Select for Charge Basis (not type 4) */}
                                  <div className="col-md-2 mb-2">
                                    <select
                                      className="form-select"
                                      onChange={(e) =>
                                        formik.setFieldValue(
                                          "frequency_optional_chargebasis_id",
                                          e.target.value
                                        )
                                      }
                                    >
                                      {serviceChargeBases.map((item, index) => {
                                        const isInvalid =
                                          item.chargebasis_id === "null" ||
                                          item.chargebasis_id === null ||
                                          item.chargebasis_id === "" ||
                                          item.chargebasis_id === undefined ||
                                          item.chargebasis_id === "undefined";

                                        if (
                                          isInvalid ||
                                          item?.basistypes_id === 4 ||
                                          item?.basistypes_id === 2
                                        )
                                          return null;

                                        return (
                                          <option
                                            key={index}
                                            value={item?.chargebasis_id}
                                            selected={
                                              item?.chargebasis_id ===
                                              formik.values
                                                .frequency_optional_chargebasis_id
                                            }
                                          >
                                            {item?.name}
                                          </option>
                                        );
                                      })}
                                    </select>
                                  </div>

                                  {/* Operator selection */}
                                  <div className="col-md-2 mb-2">
                                    <select
                                      className="form-select"
                                      value={
                                        serviceChargeBases.find(
                                          (item) => item?.basistypes_id === 4
                                        )?.operator || "+"
                                      }
                                      onChange={(e) =>
                                        handleChargeBasisChange(
                                          1,
                                          "operator",
                                          e,
                                          "",
                                          "f"
                                        )
                                      }
                                    >
                                      <option value="+">+</option>
                                      <option value="*">*</option>
                                      <option value="/">/</option>
                                    </select>
                                  </div>

                                  {/* Input field if BasisType is 4 */}
                                  <div className="col-md-2 mb-2">
                                    {serviceChargeBases.map((item, index) => {
                                      const isInvalid =
                                        item.chargebasis_id === "null" ||
                                        item.chargebasis_id === null ||
                                        item.chargebasis_id === "" ||
                                        item.chargebasis_id === undefined ||
                                        item.chargebasis_id === "undefined";

                                      if (!isInvalid && item.basistypes_id === 4) {
                                        return (
                                          <input
                                            key={index}
                                            className="form-control"
                                            type="text"
                                            name={item?.name}
                                            value={item?.name}
                                            readOnly
                                          />
                                        );
                                      }

                                      return null;
                                    })}
                                  </div>
                                </div>
                              </div>
                            </div>
                          )}
                    </div>
                  </div>
                )}

              <div className="modal-footer mt-4 mb-0">
                <button
                  type="button"
                  className="btn btn-outline-secondary rounded "
                  onClick={() => navigate("/admin/pricing/all-services")}
                >
                  <i className="fa fa-xmark" /> Cancel
                </button>
                <button
                  className="btn btn-pink rounded ms-2 "
                  type="submit"
                  onClick={() => {
                    const errors = formik.validateForm(); // validate manually
                    formik.handleSubmit(); // then submit if no errors
                  }}
                >
                  <i className="far fa-save" /> Update
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CreateServices;
